import { Component, Input, ViewChild, SimpleChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { ProfileAdvancedSearchParams } from '../profile-advanced-search-params.model';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { SerialSearchExpression } from '../../../shared/search-expression/serial-search-expression.model';
import { AffCodeSelectorComponent } from '../../../affcode/affcode-selector/affcode-selector.component';
import { ListBuilderComponent } from '../../../shared/widgets/list-builder/list-builder.component';
import { ListingCategoryService } from '../../../listing-catagories/listing-category.service';
import { ListingCategorySearchResult } from '../../../listing-catagories/listing-category-search-result.model';
import { ListingCategorySearchParams } from '../../../listing-catagories/listing-category-search-params.model';
import { ListingCategory } from '../../../listing-catagories/listing-category.model';
import { ListingSubCategoryService } from '../../../listing-catagories/listing-sub-category.service';
import { ListingSubCategorySearchResult } from '../../../listing-catagories/listing-sub-category-search-result.model';
import { ListingSubCategorySearchParams } from '../../../listing-catagories/listing-sub-category-search-params.model';
import { ListingSubCategory } from '../../../listing-catagories/listing-sub-category.model';
import { TranslationService } from '../../../shared/translation/translation.service';
import { MemberService } from '../../../member/shared/member.service';
import { MemberActivityTypeModel } from '../../../member/shared/member-activity-type.model';
import { ResultOptionEnum } from '../result-option.enum';
import { RelationTypeService } from '../../shared/relation-type.service';
import { RelationTypeSearchParams } from '../../shared/relation-type-search-params.model';
import { RelationTypeSearchResults } from '../../shared/relation-type-search-result.model';
import { RelationType } from '../../shared/relation-type-model';
import { VerticalService } from '../../../vertical/shared/vertical.service';
import { VerticalNahbService } from '../../../vertical/nahb/shared/vertical-nahb.service';
import { NahbMemberType } from '../../../vertical/nahb/shared/nahb-member-type.model';
import { NahbBusinessActivity } from '../../../vertical/nahb/shared/nahb-business-activity.model';
import { VerticalTypeEnum } from '../../../vertical/shared/vertical-type.enum';
import { VerticalNaaService } from '../../../vertical/naa/shared/vertical-naa.service';
import { NaaProfileType } from '../../../vertical/naa/shared/naa-profile-type.model';
import { CustomFieldDto } from '../../shared/dto/custom-field.dto';
import { CustomFieldService } from '../../shared/custom-field.service';
import { DataViewService } from '../../shared/data-view.service';
import { DataViewMin } from '../../shared/data-view-min.model';
import { FieldTypeEnum } from '../../../shared/search-expression/field-type.enum';
import { FeatureNameEnum } from '../../../shared/feature/feature-name.enum';
import { FeatureService } from '../../../shared/feature/feature.service';
import { Office, OfficeSearch, Official, OfficialSearch, VoterVoiceService } from '../../../integrations/voter-voice/shared/index';
//import moment from 'moment-es6';
import { MomentService } from '../../../shared/moment/moment.service';
import { CertificationOptionsModel } from '../profile-advanced-search-certifications-options.model';
import { ProfileAdvancedSearchCertificationFieldEnum } from '../dto/profile-advanced-search-certification-field.enum';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { CertificationTypeService } from 'src/app/certification/shared/certification-type.service';
import { CeuService } from 'src/app/config/ceu/ceu.service';
import { FormBuilderService } from 'src/app/form-builder/shared/service/form-builder.service';
import { FormSearch } from 'src/app/forms/shared/model/form-search.model';
import { FormSearchOptionsModel } from '../profile-advanced-search-form-search-options.model';
import { BillingService } from 'src/app/revenue/shared/billing/billing.service';
import { BillingCycle } from 'src/app/revenue/shared/billing/billing-cycle.model';
import { BinaryOperatorEnum } from 'src/app/shared/search-expression/binary-operator.enum';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-profile-advanced-search-options',
  templateUrl: 'profile-search-advanced-options.component.html',
  styleUrls: ['profile-search-advanced-options.component.less'],
  providers: [
    ListingSubCategoryService,
    TranslationService,
    MemberService,
    RelationTypeService,
    VerticalService,
    VerticalNahbService,
    VerticalNaaService,
    CustomFieldService,
    DataViewService,
  ],
  standalone: false,
})
export class ProfileSearchAdvancedOptionsComponent implements OnInit {
  @Input('hideRunThisSearchButton') hideRunThisSearchButton = false;
  @Input('searchParams')
  profileAdvancedSearchParams: ProfileAdvancedSearchParams;
  @ViewChild('affCodeSelector', { static: false }) affCodeSelector: AffCodeSelectorComponent;
  @ViewChild('affCodeExcludeSelector', { static: false }) affCodeExcludeSelector: AffCodeSelectorComponent;
  @ViewChild('memberTypeListBuilder', { static: false }) memberTypeListBuilder: ListBuilderComponent;
  @ViewChild('busActivityListBuilder', { static: false }) busActivityListBuilder: ListBuilderComponent;
  @ViewChild('profileTypeListBuilder', { static: false }) profileTypeListBuilder: ListBuilderComponent;
  @Output() public searchClicked: EventEmitter<boolean>;

  private _momentService: MomentService;

  public categories: Array<any>;
  public months: Array<string>;
  public memberActivityTypes: Array<MemberActivityTypeModel>;
  public relationTypes: Array<RelationType>;
  public nahbMemberTypes: Array<NahbMemberType>;
  public nahbBusinessActivity: Array<NahbBusinessActivity>;
  public naaProfileTypes: Array<NaaProfileType>;
  public customFields: Array<CustomFieldDto>;
  public nahbTabVisible: boolean;
  public naaTabVisible: boolean;
  public fieldTypeEnum: object = FieldTypeEnum;
  public dataViews: Array<DataViewMin>;
  public showSaveSearch: boolean;
  public showdeleteDataView: boolean;
  public searchName: string;
  public allUsers: boolean;
  public savingSearch: boolean;
  public isSearching: boolean;
  public certificationFields = ProfileAdvancedSearchCertificationFieldEnum;
  public certificationTypes = new Array<SelectItem>();
  public formsList = new Array<SelectItem>();
  public ceuTypes = new Array<SelectItem>();
  public billingCycles: Array<BillingCycle>;

  // voter voice fields
  public hasVoterVoice: boolean = false;
  public voterVoiceDataLoading: boolean = false;
  public voterVoiceOffices: Office[] = null;
  public voterVoiceOfficials: Official[] = null;
  binaryOperatorEnum = BinaryOperatorEnum;

  private _booleanFieldNames: string[] = ['Member', 'Prospect', 'OrgIndicator'];

  public constructor(
    private _certificationTypeService: CertificationTypeService,
    private _ceuService: CeuService,
    private _customFieldService: CustomFieldService,
    private _dataViewService: DataViewService,
    private _listingCategorySearchService: ListingCategoryService,
    private _listingSubCategorySearchService: ListingSubCategoryService,
    private _translationService: TranslationService,
    private _memberService: MemberService,
    private _relationTypeService: RelationTypeService,
    private _verticalTypeService: VerticalService,
    private _verticalNahbService: VerticalNahbService,
    private _featureService: FeatureService,
    private _voterVoiceService: VoterVoiceService,
    private _verticalNaaService: VerticalNaaService,
    private _formBuilderService: FormBuilderService,
    private _billingService: BillingService,
    momentService: MomentService,
    private _confirmationService: ConfirmationService,
    private _notificationService: NotificationService
  ) {
    this.profileAdvancedSearchParams = new ProfileAdvancedSearchParams();
    this.categories = new Array<any>();
    this.months = new Array<string>();
    this.memberActivityTypes = new Array<MemberActivityTypeModel>();
    this.relationTypes = new Array<RelationType>();
    this.nahbMemberTypes = new Array<NahbMemberType>();
    this.naaProfileTypes = new Array<NaaProfileType>();
    this.nahbBusinessActivity = new Array<NahbBusinessActivity>();
    this.nahbTabVisible = false;
    this.naaTabVisible = false;
    this.customFields = new Array<CustomFieldDto>();
    this.dataViews = new Array<DataViewMin>();
    this.searchName = '';
    this.savingSearch = false;
    this.allUsers = false;
    this.showSaveSearch = false;
    this.showdeleteDataView = false;
    this._momentService = momentService;
    this.searchClicked = new EventEmitter<boolean>();
  }

  ngOnInit() {
    let categoryParams = new ListingCategorySearchParams();
    let subCategoryParams = new ListingSubCategorySearchParams();
    let relationTypeSearchParams = new RelationTypeSearchParams();
    categoryParams.PageNumber = 0;
    categoryParams.PageSize = 0;
    subCategoryParams.PageNumber = 0;
    subCategoryParams.PageSize = 0;
    relationTypeSearchParams.PageNumber = 0;
    relationTypeSearchParams.PageSize = 0;
    relationTypeSearchParams.OrderBy = 'RelationType';
    this.isSearching = false;
    let formSearchParams = new FormSearch();
    formSearchParams.PageSize = 0;
    formSearchParams.ShowInactive = true;

    let categoryResults = new Array<ListingCategory>();
    let subCategoryResults = new Array<ListingSubCategory>();
    Promise.all([
      this._listingSubCategorySearchService.getCategoriesAndSubCategoriesForProfileSelector().then((data) => {
        this.categories = data;
      }),
      this._memberService.getMemberActivityTypes().then((results) => {
        this.memberActivityTypes = results;
      }),
      this._relationTypeService.search(relationTypeSearchParams).then((data) => {
        this.relationTypes = data.Result;
      }),
      this._verticalTypeService.GetCurrentUserVerticalType().then((verticalType) => {
        this.nahbTabVisible = verticalType == VerticalTypeEnum.HBA;
        this.naaTabVisible = verticalType == VerticalTypeEnum.ApartmentAssociation;
      }),
      this._verticalNahbService.getHbaMemberTypes().then((data) => {
        this.nahbMemberTypes = data;
      }),
      this._verticalNahbService.getHbaBusinessActivityTypes().then((data) => {
        this.nahbBusinessActivity = data;
      }),
      this._verticalNaaService.getNaaProfileTypes().then((data) => {
        this.naaProfileTypes = data;
      }),
      this._customFieldService.searchCustomFields().then((data) => {
        this.customFields = data.Result;
      }),
      this._dataViewService.getSavedDataViews().then((data) => {
        this.dataViews = data;
      }),
      this._featureService.has(FeatureNameEnum.VoterVoice).then(
        (hasIt) => {
          if (hasIt) return this._voterVoiceService.hasVoterVoiceSettings().then((settingsAreSet) => (this.hasVoterVoice = settingsAreSet));
        },
        function () {}
      ),
      this._certificationTypeService.getAllCertificationTypes().then((data) => {
        this.certificationTypes = (data.Result as Array<any>)?.map<SelectItem>((x) => {
          return { label: x.Name, value: x.CertificationTypeID };
        });
      }),
      this._ceuService.getCeCreditTypes().then((data) => {
        this.ceuTypes = data.map((x) => {
          return { label: x.CECreditType, value: x.CECreditTypeID };
        });
      }),
      this._formBuilderService.searchForms(formSearchParams).then((data) => {
        let inactiveStr = '*INACTIVE* ';
        let activeForms = [];
        let inactiveForms = [];
        data.Result.forEach((x) => {
          x.Inactive
            ? inactiveForms.push({ label: inactiveStr + x.Title, value: x.Id })
            : activeForms.push({ label: x.Title, value: x.Id });
        });
        this.formsList = [...activeForms, ...inactiveForms];
        this._billingService.getBillingCycles().then((data) => {
          this.billingCycles = data.reverse();
        });
      }),
    ]).then(() => {
      if (this.profileAdvancedSearchParams.ContactInfoSearchExpressions.length === 0) {
        this.addContactInfoSearchField();
      }
    });

    this.months = this._translationService.getMonths();
  }

  public addFormSearchField = (): void => {
    this.profileAdvancedSearchParams.FormSearchExpressions.push(new FormSearchOptionsModel());
  };

  public removeFormSearchField = (i: number): void => {
    this.profileAdvancedSearchParams.FormSearchExpressions.splice(i, 1);
  };

  public addFormSearchSubSearchField(i: number): void {
    this.profileAdvancedSearchParams.FormSearchExpressions[i].SearchExpressions.push(new SerialSearchExpression());
  }

  public removeFormSearchSubSearchField(c: number, i: number): void {
    this.profileAdvancedSearchParams.FormSearchExpressions[c].SearchExpressions.splice(i, 1);
  }

  public addContactInfoSearchField = (): void => {
    this.profileAdvancedSearchParams.ContactInfoSearchExpressions.push(new SerialSearchExpression());
  };

  public removeContactInfoSearchField = (i: number): void => {
    this.profileAdvancedSearchParams.ContactInfoSearchExpressions.splice(i, 1);
  };

  public addCategoriesSearchField = (): void => {
    this.profileAdvancedSearchParams.CategorySearchExpressions.push(new SerialSearchExpression());
  };

  public removeCategoriesSearchField = (i: number): void => {
    this.profileAdvancedSearchParams.CategorySearchExpressions.splice(i, 1);
  };

  public addEventsSearchField = (): void => {
    this.profileAdvancedSearchParams.EventsSearchExpressions.push(new SerialSearchExpression());
  };

  public removeEventsSearchField = (i: number): void => {
    this.profileAdvancedSearchParams.EventsSearchExpressions.splice(i, 1);
  };

  public addMemberActivitySearchField = (): void => {
    let newExpression = new SerialSearchExpression();
    let today = this._momentService.getMomentByDate(new Date()).startOf('day');

    newExpression.Value = today.format('YYYY-MM-DD');
    this.profileAdvancedSearchParams.MemberActivitySearchExpressions.push(newExpression);
  };

  public removeMemberActivitySearchField = (i: number): void => {
    this.profileAdvancedSearchParams.MemberActivitySearchExpressions.splice(i, 1);
  };

  /**
   * + voter voice search field
   */
  public addVoterVoiceSearchField(): void {
    this.profileAdvancedSearchParams.VoterVoicehExpressions.push(new SerialSearchExpression());
  }

  /**
   * - voter voice search field
   */
  public removeVoterVoiceSearchField(i: number): void {
    this.profileAdvancedSearchParams.VoterVoicehExpressions.splice(i, 1);
  }

  public addCertificationSearchField(): void {
    this.profileAdvancedSearchParams.CertificationOptions.push(new CertificationOptionsModel());
  }

  public removeCertificationSearchField(i: number): void {
    this.profileAdvancedSearchParams.CertificationOptions.splice(i, 1);
  }

  public addCertificationSubSearchField(i: number): void {
    this.profileAdvancedSearchParams.CertificationOptions[i].SearchExpressions.push(new SerialSearchExpression());
  }

  public removeCertificationSubSearchField(c: number, i: number): void {
    this.profileAdvancedSearchParams.CertificationOptions[c].SearchExpressions.splice(i, 1);
  }

  public certificationTypeChange(event, certification: CertificationOptionsModel) {
    // value isn't consumed by the search here, we'll leverage it for readability.
    const certType = this.certificationTypes.find((x) => x.value === event.value);
    certification.Value = certType.label;
  }

  public ceuCreditTypeChange(event, certification: CertificationOptionsModel) {
    // value isn't consumed by the search here, we'll leverage it for readability.
    const ceuType = this.ceuTypes.find((x) => x.value === event.value);
    certification.Value = ceuType.label;
  }

  /**
   * voter voice search field changed
   */
  public handleVoterVoiceFieldChange(searchExpression: SerialSearchExpression): void {
    if (!searchExpression) return;

    // reset value because the dropdown is switching out
    searchExpression.Value = '';
  }

  /**
   * change search expression value
   * @param searchExpression
   */
  public setSearchExpression(searchExpression: SerialSearchExpression, value: string): void {
    if (!searchExpression) return;

    setTimeout(() => (searchExpression.Value = value));
  }

  /**
   * handle field name change for contact info
   * @param searchExpression
   */
  public handleContactInfoSearchExpressionFieldChange(searchExpression: SerialSearchExpression): void {
    if (!searchExpression || !searchExpression.Field) return;

    if (this._booleanFieldNames.indexOf(searchExpression.Field) > -1) {
      if (searchExpression.FieldType != FieldTypeEnum.Bool) {
        searchExpression.FieldType = FieldTypeEnum.Bool;
        searchExpression.Value = 'true';
      }
    } else {
      if (searchExpression.FieldType != FieldTypeEnum.String) {
        searchExpression.FieldType = FieldTypeEnum.String;
        searchExpression.Value = '';
      }
    }
  }

  public toggleSaveElement(): void {
    this.showSaveSearch = !this.showSaveSearch;
    this.searchName = '';
    this.allUsers = false;
  }
  public toggleDeleteElement(): void {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.search.advanced.my-data-views.confirm-delete-message'),
      key: 'deleteDataViewCD',
      accept: () => {
        this._dataViewService
          .deleteDataView(this.profileAdvancedSearchParams.DataViewId)
          .then(() => {
            this._notificationService.translateSuccess('reports.saved-queries.delete-success-message');
            this.searchDataViews();
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
  public searchDataViews() {
    this._dataViewService.getSavedDataViews().then((data) => {
      this.dataViews = data;
      this.profileAdvancedSearchParams.DataViewId = 0;
    });
  }

  /*
    // Save a search
    */
  public saveSearch(): void {
    this.savingSearch = true;
    this._dataViewService
      .saveDataView(this.profileAdvancedSearchParams, this.searchName, this.allUsers)
      .then((newId) => {
        this._dataViewService.getSavedDataViews().then((data) => {
          this.dataViews = data;
          this.profileAdvancedSearchParams.DataViewId = newId;
        });
        this.savingSearch = false;
        this.showSaveSearch = !this.showSaveSearch;
      })
      .catch(() => {
        this.savingSearch = false;
      });
  }

  /**
   * user selected voter voice tab
   */
  public async handleVoterVoiceTabSelected(): Promise<void> {
    if (this.voterVoiceDataLoading || (this.voterVoiceOffices != null && this.voterVoiceOfficials != null)) return;

    this.voterVoiceDataLoading = true;

    try {
      let officeSearchParams: OfficeSearch = new OfficeSearch();
      let officialSearchParams: OfficeSearch = new OfficialSearch();

      officeSearchParams.PageNumber = officeSearchParams.PageSize = officialSearchParams.PageNumber = officialSearchParams.PageSize = 0;

      // make api calls
      let officePromise: Promise<PagedResult<Office[]>> = this._voterVoiceService.searchOffices(officeSearchParams);
      let officialPromise: Promise<PagedResult<Official[]>> = this._voterVoiceService.searchOfficials(officialSearchParams);

      // wait
      let [officesResult, officialsResult] = await Promise.all([officePromise, officialPromise]);

      // get offices result
      if (officesResult && officesResult.Result) this.voterVoiceOffices = officesResult.Result;
      else this.voterVoiceOffices = [];

      // get officials result
      if (officialsResult && officialsResult.Result) this.voterVoiceOfficials = officialsResult.Result;
      else this.voterVoiceOfficials = [];
    } catch (e) {
    } finally {
      this.voterVoiceDataLoading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      this.affCodeSelector.updateSelectedAffCodesFromValue();
      this.affCodeExcludeSelector.updateSelectedAffCodesFromValue();
      if (this.busActivityListBuilder) this.busActivityListBuilder.updateSelectedItemsFromValue();
      if (this.memberTypeListBuilder) this.memberTypeListBuilder.updateSelectedItemsFromValue();
      if (this.memberTypeListBuilder) this.memberTypeListBuilder.updateSelectedItemsFromValue();
      if (this.profileTypeListBuilder) this.profileTypeListBuilder.updateSelectedItemsFromValue();
    });
  }

  public emitSearch() {
    this.isSearching = true;
    this.searchClicked.emit(true);
  }
}
